/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Error_BodyInputs */

const en_gc_editor_error_body = /** @type {(inputs: Gc_Editor_Error_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your connection and try again. If your browser does not support WebGPU, try the WebGL version in a new tab.`)
};

const zh_gc_editor_error_body = /** @type {(inputs: Gc_Editor_Error_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请检查网络后重试。如果浏览器不支持 WebGPU，可以在新标签页尝试 WebGL 版本。`)
};

/**
* | output |
* | --- |
* | "Check your connection and try again. If your browser does not support WebGPU, try the WebGL version in a new tab." |
*
* @param {Gc_Editor_Error_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_error_body = /** @type {((inputs?: Gc_Editor_Error_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Error_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_error_body(inputs)
	return zh_gc_editor_error_body(inputs)
});
export { gc_editor_error_body as "gc.editor.error_body" }